export class numbers {

    //average german nutrition percentages
    public static ger_avg_meat_perc: number = 0.115;
    public static ger_avg_pork_perc: number = 0.6;
    public static ger_avg_beef_perc: number = 0.2;
    public static ger_avg_chicken_perc: number = 0.2;
    public static ger_avg_fish_perc: number = 0.015;
    public static ger_avg_egg_perc: number = 0.02;
    public static ger_avg_cheese_perc: number = 0.08;
    public static ger_avg_dairy_perc: number = 0.085;
    public static ger_avg_milk_perc: number = 0.42;
    public static ger_avg_joghurt_perc: number = 0.14;
    public static ger_avg_cream_perc: number = 0.05;
    public static ger_avg_butter_perc: number = 0.39;
    public static ger_avg_fruit_perc: number = 0.05;
    public static ger_avg_vegetables_perc: number = 0.02;
    public static ger_avg_grain_perc: number = 0.345;
    public static ger_avg_nuts_perc: number = 0.04;
    public static ger_avg_frozen_perc: number = 0.045;
    public static ger_avg_sweets_perc: number = 0.09;
    public static ger_avg_oil_perc: number = 0.095;

    //calories per kg
    public static cal_meat:number = 2426.177893;
    public static cal_pork:number = 2377;
    public static cal_beef:number = 2906;
    public static cal_chicken:number = 2200;
    public static cal_fish:number = 1300;
    public static cal_egg:number = 1440;
    public static cal_cheese:number = 4036;
    public static cal_dairy:number = 785.98885;
    public static cal_milk:number = 510;
    public static cal_joghurt:number = 640;
    public static cal_cream:number = 3400;
    public static cal_butter:number = 7100;
    public static cal_fruit:number = 581.480287;
    public static cal_vegetables:number = 241.782074;
    public static cal_grain:number = 3117.692378;
    public static cal_nuts:number = 5706.395349;
    public static cal_frozen:number = 2860.121547;
    public static cal_sweets:number = 3669.993548;
    public static cal_oil:number = 8480.571214;

    //CO2 footprint per kg
    public static fp_meat:number = 6.36891192;
    public static fp_pork:number = 4.6;
    public static fp_beef:number = 13.6;
    public static fp_chicken:number = 5.5;
    public static fp_fish:number = 6.14;
    public static fp_egg:number = 3;
    public static fp_cheese:number = 5.7;
    public static fp_dairy:number = 1.59953058;
    public static fp_milk:number = 1.34;
    public static fp_joghurt:number = 1.48;
    public static fp_cream:number = 4.17;
    public static fp_butter:number = 10.25;
    public static fp_fruit:number = 0.391846;
    public static fp_vegetables:number = 0.51300527;
    public static fp_nuts:number = 1.151163;
    public static fp_grain:number = 0.577677;
    public static fp_frozen:number = 3.202762;
    public static fp_sweets:number = 3.069637;
    public static fp_oil:number = 3.030891;

    //CO2 emissions per calorie for Germany in grams
    public static get ger_CO2_per_cal_meat(): number { return this.fp_meat / this.cal_meat * 1000 } ;
    public static get ger_CO2_per_cal_pork(): number { return this.fp_pork / this.cal_pork * 1000 } ;
    public static get ger_CO2_per_cal_beef(): number { return this.fp_beef / this.cal_beef * 1000 } ;
    public static get ger_CO2_per_cal_chicken(): number { return this.fp_chicken / this.cal_chicken * 1000 } ;
    public static get ger_CO2_per_cal_fish(): number { return this.fp_fish / this.cal_fish * 1000 } ;
    public static get ger_CO2_per_cal_egg(): number { return this.fp_egg / this.cal_egg * 1000 } ;
    public static get ger_CO2_per_cal_cheese(): number { return this.fp_cheese / this.cal_cheese * 1000 } ;
    public static get ger_CO2_per_cal_dairy(): number { return this.fp_dairy / this.cal_dairy * 1000 } ;
    public static get ger_CO2_per_cal_milk(): number { return this.fp_milk / this.cal_milk * 1000 } ;
    public static get ger_CO2_per_cal_joghurt(): number { return this.fp_joghurt / this.cal_joghurt * 1000 } ;
    public static get ger_CO2_per_cal_cream(): number { return this.fp_cream / this.cal_cream * 1000 } ;
    public static get ger_CO2_per_cal_butter(): number { return this.fp_butter / this.cal_butter * 1000 } ;
    public static get ger_CO2_per_cal_fruit(): number { return this.fp_fruit / this.cal_fruit * 1000 } ;
    public static get ger_CO2_per_cal_vegetables(): number { return this.fp_vegetables / this.cal_vegetables * 1000 } ;
    public static get ger_CO2_per_cal_grain(): number { return this.fp_grain / this.cal_grain * 1000 } ;
    public static get ger_CO2_per_cal_nuts(): number { return this.fp_nuts / this.cal_nuts * 1000 } ;
    public static get ger_CO2_per_cal_frozen(): number { return this.fp_frozen / this.cal_frozen * 1000 } ;
    public static get ger_CO2_per_cal_sweets(): number { return this.fp_sweets / this.cal_sweets * 1000 } ;
    public static get ger_CO2_per_cal_oil(): number { return this.fp_oil / this.cal_oil * 1000 } ;

    //Grams per portion
    public static gram_per_portion_meat: number = 120;
    public static gram_per_portion_pork:number = 85;
    public static gram_per_portion_beef:number = 85;
    public static gram_per_portion_chicken:number = 120;
    public static gram_per_portion_fish:number = 120;
    public static gram_per_portion_egg:number = 60;
    public static gram_per_portion_cheese:number = 50;
    public static gram_per_portion_dairy:number = 200;
    public static gram_per_portion_milk:number = 245;
    public static gram_per_portion_joghurt:number = 170;
    public static gram_per_portion_cream:number = 30;
    public static gram_per_portion_butter:number = 14;
    public static gram_per_portion_fruit:number = 150;
    public static gram_per_portion_vegetables:number = 140;
    public static gram_per_portion_nuts:number = 28;
    public static gram_per_portion_grain:number = 150;
    public static gram_per_portion_frozen:number = 200;
    public static gram_per_portion_sweets:number = 70;
    public static gram_per_portion_oil:number = 14;
    public static average_portions_per_day: number = 15;

    //food waste constants
    public static ger_waste_perc_meat: number = 0.16;
    public static ger_waste_perc_fish: number = 0.26;
    public static ger_waste_perc_dairy: number = 0.14;
    public static ger_waste_perc_egg: number = 0.16;
    public static ger_waste_perc_fruit: number = 0.29;
    public static ger_waste_perc_vegetables: number = 0.29;
    public static ger_waste_perc_grain: number = 0.217071;
    public static ger_waste_perc_nuts: number = 0.15;
    public static ger_waste_perc_frozen: number = 0.15;
    public static ger_waste_perc_sweets: number = 0.15;
    public static ger_waste_perc_oil: number = 0.15;

    //relative factors for frozen foods and sweets
    public static relative_never: number = 0;
    public static relative_rarely: number = 0.5;
    public static relative_nowAndThen: number = 1;
    public static relative_often: number = 1.5;
    public static relative_frequently: number = 2;

    //constant factor for emissions from home (frige, cooking, ...)
    public static ger_home_factor: number = 1.2;

    //food waste factors
    public static waste_rarely: number = 0.5;
    public static waste_nowAndThen: number = 1;
    public static waste_often: number = 1.5;
    
    //German average values
    public static ger_avg_calories: number = 2785;
    private static _ger_avg_emissions: number = 3412; //value for food purchases (system boundary: supermarket)
    public static get ger_avg_emissions(): number { return this._ger_avg_emissions * this.ger_home_factor; }; //value includes way to supermarket, frige, oven, garbage, ...
    public static get ger_avg_emissions_per_calorie(): number { return this.ger_avg_emissions / this.ger_avg_calories; };
    public static get ger_avg_emissions_per_year(): number { return this.ger_avg_emissions * 365.25 / 1000; };

    // //Worldwide CO2 budgets
    // public static ww_yearly_budget_2_degrees: number = 1899; // old
    // public static ww_yearly_budget_1_5_degrees: number = 676; // old
    public static ww_yearly_budget_1_5_degrees_67_chance: number = 137; // new
    public static ww_yearly_budget_2_degrees_67_chance: number = 1383; // new
    public static ww_yearly_budget_1_5_degrees_50_chance: number = 721; // new
    public static ww_yearly_budget_2_degrees_50_chance: number = 2555; // new
    public static ww_yearly_budget_1_5_degrees_33_chance: number = 1651; // new
    public static ww_yearly_budget_2_degrees_33_chance: number = 4408; // new
    public static get ww_yearly_budget_1_5_degrees_67_chance_per_calorie(): number { return this.ww_yearly_budget_1_5_degrees_67_chance / this.ger_avg_calories; };
    public static get ww_yearly_budget_2_degrees_67_chance_per_calorie(): number { return this.ww_yearly_budget_2_degrees_67_chance / this.ger_avg_calories; };
    public static get ww_yearly_budget_1_5_degrees_50_chance_per_calorie(): number { return this.ww_yearly_budget_1_5_degrees_50_chance / this.ger_avg_calories; };
    public static get ww_yearly_budget_2_degrees_50_chance_per_calorie(): number { return this.ww_yearly_budget_2_degrees_50_chance / this.ger_avg_calories; };
    public static get ww_yearly_budget_1_5_degrees_33_chance_per_calorie(): number { return this.ww_yearly_budget_1_5_degrees_33_chance / this.ger_avg_calories; };
    public static get ww_yearly_budget_2_degrees_33_chance_per_calorie(): number { return this.ww_yearly_budget_2_degrees_33_chance / this.ger_avg_calories; };
    public static get ww_daily_budget_1_5_degrees_67_chance(): number { return this.ww_yearly_budget_1_5_degrees_67_chance / 365.25 * 1000; };
    public static get ww_daily_budget_2_degrees_67_chance(): number { return this.ww_yearly_budget_2_degrees_67_chance / 365.25 * 1000; };
    public static get ww_daily_budget_1_5_degrees_50_chance(): number { return this.ww_yearly_budget_1_5_degrees_50_chance / 365.25 * 1000; };
    public static get ww_daily_budget_2_degrees_50_chance(): number { return this.ww_yearly_budget_2_degrees_50_chance / 365.25 * 1000; };
    public static get ww_daily_budget_1_5_degrees_33_chance(): number { return this.ww_yearly_budget_1_5_degrees_33_chance / 365.25 * 1000; };
    public static get ww_daily_budget_2_degrees_33_chance(): number { return this.ww_yearly_budget_2_degrees_33_chance / 365.25 * 1000; };
    public static get ww_daily_budget_1_5_degrees_67_chance_per_calorie(): number { return this.ww_daily_budget_1_5_degrees_67_chance / this.ger_avg_calories; };
    public static get ww_daily_budget_2_degrees_67_chance_per_calorie(): number { return this.ww_daily_budget_2_degrees_67_chance / this.ger_avg_calories; };
    public static get ww_daily_budget_1_5_degrees_50_chance_per_calorie(): number { return this.ww_daily_budget_1_5_degrees_50_chance / this.ger_avg_calories; };
    public static get ww_daily_budget_2_degrees_50_chance_per_calorie(): number { return this.ww_daily_budget_2_degrees_50_chance / this.ger_avg_calories; };
    public static get ww_daily_budget_1_5_degrees_33_chance_per_calorie(): number { return this.ww_daily_budget_1_5_degrees_33_chance / this.ger_avg_calories; };
    public static get ww_daily_budget_2_degrees_33_chance_per_calorie(): number { return this.ww_daily_budget_2_degrees_33_chance / this.ger_avg_calories; };

}
